var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-text',[_c('b',[_vm._v("Hey! Diese Funktion ist leider noch nicht fertig! Aber sei nicht traurig! Sie wird so schnell wie möglich fertig gestellt!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }